import Skeleton from "react-loading-skeleton";


export default function PlayerLoader() {
    return (
        <div className="col-span-full w-full space-y-8 lg:col-span-2">

            <Skeleton className="h-[250px] lg:h-[450px]" />
            <div>
                <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                    <Skeleton />
                </h1>
                <h2 className="pb-4 text-sm leading-[1.7142857] text-slate-400">
                    <Skeleton />
                </h2>

                <div className="flex gap-4">
                    <Skeleton />
                </div>
                <p className="mt-4 text-sm text-slate-400 leading-6">
                    <Skeleton count={5} />
                </p>
            </div>
        </div>
    )
};